@if (!loading) {
  <div class="login-page" [ngClass]="{ 'mobile-login-page': baseService.isMobile }">
    <div class="header">
      <a [href]="homeUrl">JECRM</a>
    </div>
    <div class="card-pf">
      <div class="title">
        <h1 class="title-text">{{ 'sign_in_account' | translate }}</h1>
      </div>
      <div class="content">
        @if (loginForm) {
          <div [formGroup]="loginForm" class="form" (keydown.enter)="onSubmit()">
            <app-input
              labelType="floating"
              id="username"
              [required]="true"
              placeholder="{{ 'enter_your_e-mail' | translate }}"
              [invalid]="loginForm.controls.email.invalid && loginForm.controls.email.touched"
              [formControl]="loginForm.controls.email"
            />
            <app-input
              labelType="floating"
              id="password"
              inputType="password"
              [toggleMask]="true"
              [required]="true"
              placeholder="{{ 'enter_password' | translate }}"
              [invalid]="loginForm.controls.password.invalid && loginForm.controls.password.touched"
              [formControl]="loginForm.controls.password"
            />
            <a (click)="onResetPassword()" class="reset-password">
              {{ 'forgot_password' | translate }}
            </a>
            <app-button [disabled]="isLogging" [full]="true" (onChangeClick)="onSubmit()">
              {{ 'sign_in' | translate }}
            </app-button>
          </div>
        }
        <div class="info">
          <div class="registration">
            {{ 'new_user' | translate }}
            <a (click)="onRegister()">{{ 'sign_up' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (loading) {
  <div class="vw-100 vh-100">
    <div class="d-flex justify-content-center align-items-center vh-100">
      <app-loader></app-loader>
    </div>
  </div>
}
